import { actorSchema } from "@-/dev.improve.haniverse.database.schemas.actor.schema";
import { ActorDatabaseContext } from "@-/dev.improve.haniverse.contexts.database.actor";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { useMutation } from "@-/com.npmjs.tanstack__react-query";
import { eq } from "@-/com.npmjs.drizzle-orm";

export function useResetGraphemeMeaningCard() {
  const [actorDb] = useContextSelectors(ActorDatabaseContext, (c) => c.db);

  return useMutation({
    mutationFn: async (input: { grapheme: string }): Promise<void> => {
      const meaningRow = await actorDb(
        import.meta.location,
      ).query.userGraphemeMeaningCard.findFirst({
        where: { grapheme: input.grapheme },
        with: { userCard: true },
      });
      const existing = meaningRow?.userCard;
      if (existing === undefined) {
        return;
      }

      if (existing.fsrsCardId === null) {
        await actorDb(import.meta.location)
          .softDelete(actorSchema.userCard)
          .where(eq(actorSchema.userCard.id, existing.id));
        await actorDb(import.meta.location)
          .softDelete(actorSchema.userGraphemeMeaningCard)
          .where(eq(actorSchema.userGraphemeMeaningCard.userCardId, existing.id));
        return;
      }

      await actorDb(import.meta.location)
        .update(actorSchema.userGraphemeMeaningCard)
        .set({ description: null })
        .where(eq(actorSchema.userGraphemeMeaningCard.userCardId, existing.id));
    },
    mutationKey: ["resetGraphemeMeaningCard"],
  });
}
